export const CURVA_FILE_EXTENSION = ".curva";
export const CURVA_MIME_TYPE = "application/vnd.curva+zip";
